import React, { useState } from "react";
import SearchIcon from "../Assets/images/searchicon.png";
import upload from "../Assets/images/upload.png";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect } from "react";
import { ReactComponent as IBMainLogo } from "../Assets/svgs/ib-main-logo.svg";
import { toast } from "react-toastify";
import { Box, ClickAwayListener, debounce, Typography } from "@mui/material";
import { appSettingDataSelector } from "../../redux/appSetting";
import { useSelector } from "react-redux";
import { fetchFile, getFilterdData, toTitleCase } from "../../lib/helper";
import { ReactComponent as DownloadIcon } from "../Assets/svgs/download-menu.svg";
import { ReactComponent as DownArrow } from "../Assets/svgs/down-arrow-filled.svg";
import { autosuggest } from "../../services/SearchApi";
// import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import UploadImageModal from "../Modals/UploadImageModal";
import { ReactComponent as uploadIcon } from "../Assets/svgs/upload-icon-model.svg"

const SearchBar = ({
  isDownloadButton,
  imageData,
  isSearchtext,
  isMoreInfoWall,
  shootId,
  imageAlignment,
  imageUrl,
  isColor,
  layoutHeroClass,
  imageid,
  FullImageWall,
  enableBackground,
  animationStyle,
  animationDropDownStyle,
  showTitleHeader,
}) => {
  const navigate = useNavigate();
  const [freeWeeklyImage, setFreeWeeklyImage] = useState("");
  const [freeImageValidity, setFreeImageValidity] = useState("");
  const [openFreeImageForm, setOpenFreeImageForm] = React.useState(false);
  const [divShow, setDivShow] = useState(false);
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const [selectedSearchOption, setSelectedSearchOption] = useState("Images");
  const [searchText, setSearchText] = useState("");
  const { searchKeyword } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedMenuType = searchParams.get("menu_type");
  const isBrowseCategory = searchParams.get("br");
  const isSearchContent = searchParams.get("sc");
  const tabContent = searchParams.get("tab");
  const { appSettingData } = useSelector(appSettingDataSelector);
  const [autoComplete, setAutoComplete] = useState([]);
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [cursor, setCursor] = useState(-1);
  const [isImagesSearch, setIsImagesSearch] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadedImageData, setUploadedImageData] = useState(null);
  const location = useLocation();

  const tabMenu = searchParams.get("tab");
  const handleKeyDown = (e) => {
    if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < autoComplete.length - 1) {
      setCursor(cursor + 1);
    }
    if (e.keyCode == 13) {
      setShowAutoComplete(false);
      if (autoComplete[cursor]) {
        setSearchText(autoComplete[cursor]?.displayKeyword);
        if (selectedSearchOption === "Images") {
          if (tabContent === "stars") {
            navigate(
              `/stars/search/${autoComplete[cursor]?.displayKeyword}?sc=1`
            );
          } else {
            navigate(`/search/${autoComplete[cursor]?.displayKeyword}?sc=1`);
          }
        } else if (selectedSearchOption === "Images Search") {
          navigate(
            `/image-search/search/${autoComplete[cursor]?.displayKeyword}?sc=1`
          );
        } else {
          navigate(
            `/video/search/${autoComplete[cursor]?.displayKeyword}?sc=1`
          );
        }
      } else {
        if (selectedSearchOption === "Images") {
          if (tabContent === "stars") {
            navigate(`/stars/search/${searchText}?sc=1`);
          } else {
            navigate(`/search/${searchText}?sc=1`);
          }
        } else if (selectedSearchOption === "Images Search") {
          navigate(`/image-search/search/${searchText}?sc=1`);
        } else {
          navigate(`/video/search/${searchText}?sc=1`);
        }
      }
    }
  };

  const handleSubmitChangeOfSelect = (selectedWord) => {
    if (selectedWord === "Images") {
      if (tabContent === "stars") {
        navigate(`/stars/search/${searchText}?sc=1`);
      } else {
        navigate(`/search/${searchText}?sc=1`);
      }
    } else if (selectedWord === "Videos") {
      navigate(`/video/search/${searchText}?sc=1`);
    } else if (selectedWord === "Images Search") {
      navigate(`/image-search/search/${searchText}?sc=1`);
    }
  };

  const handleFreeWeeklyImage = () => {
    let data = getFilterdData(
      appSettingData?.items?.features?.weekly_image,
      "key_name",
      "weekly_image_name"
    );
    if (data?.length) {
      setFreeWeeklyImage(data?.[0]?.key_value);
    }
    let imageValidity = getFilterdData(
      appSettingData?.items?.features?.weekly_image,
      "key_name",
      "weekly_image_validity"
    );
    if (imageValidity?.length) {
      setFreeImageValidity(new Date(imageValidity?.[0]?.key_value));
    }
  };

  useEffect(() => {
    if (searchKeyword !== undefined && isBrowseCategory != 1) {
      setSearchText(searchKeyword);
      setCursor(-1);
    }
    if (isBrowseCategory == 1) {
      if (isSearchContent != 1) {
        setSearchText("");
      } else {
        if (searchKeyword !== undefined) {
          setSearchText(searchKeyword);
          setCursor(-1);
        }
      }
    }
    if (
      location?.pathname?.toString()?.includes("video/") ||
      location?.pathname?.toString()?.includes("videoentireshoot/") ||
      selectedMenuType === "video"
    ) {
      setSelectedSearchOption("Videos");
    }
    // if (
    //   location?.pathname?.toString()?.includes("image-search/") ||
    //   selectedMenuType === "image-search"
    // ) {
    //   setSelectedSearchOption("Images Search");
    // }
  }, [location]);

  useEffect(() => {
    document.onclick = (args) => {
      if (autoComplete) {
        setShowAutoComplete(false);
      }
    };
  }, []);

  useEffect(() => {
    if (appSettingData) {
      handleFreeWeeklyImage();
    }
  }, [appSettingData]);

  function capitalizeTheFirstLetterOfEachWord(word) {
    var separateWord = word?.toLowerCase()?.split(" ");
    for (var i = 0; i < separateWord.length; i++) {
      separateWord[i] =
        separateWord[i].charAt(0)?.toUpperCase() + separateWord[i].substring(1);
    }
    return separateWord.join(" ");
  }
  const handleClickAway = () => {
    setDivShow(false);
  };
  const handleDownloadFreeImage = async () => {
    // const token = localStorage?.getItem("token");
    // if (token) {
    // let data = appSettingData.items?.features?.weekly_image?.filter(
    //   (item) => {
    //     return item.key_name == "weekly_zip_url";
    //   }
    // );
    if (appSettingData.items?.features) {
      let data = getFilterdData(
        appSettingData.items?.features?.weekly_image,
        "key_name",
        "weekly_zip_url"
      );
      if (data.length) {
        toast.promise(fetchFile(data[0].key_value), {
          pending: "Downloading your file....",
          success: "Successfully downloaded.",
          error: "Failed to download file.",
        });
      }
    }
    // } else {
    //   setOpenFreeImageForm(true);
    // }
  };

  const handleClose = () => {
    setOpenFreeImageForm(false);
  };

  const handleUploadModalOpen = () => {
    setIsUploadModalOpen(true); // Open the modal
  };
  const handleUploadModalClose = () => {
    setIsUploadModalOpen(false); // Close the modal
  };

  const handleLasts = (data) => {
    setUploadedImageData(data);
  };

  const handleAllFunctionForUploadModal = () =>{
    let pathName = location?.pathname?.toString()?.includes("image-search/")
    if (pathName) {
      handleUploadModalOpen();
    } else {
      handleUploadModalOpen();
      navigate("/?menu_type=image-search");
    }
  }

  // className="searchInput"
  return (
    <>
      <Box component="div">
        {isSearchtext && (
          <>
            <div  className={showTitleHeader?'searchInput':'searchInputForBrand'}>
              {showTitleHeader==true?"": <span className="brandLogo">
                 <Link
                              to={
                                tabMenu !== "stars" &&
                                !location?.pathname?.toString()?.includes("stars/")
                                  ? "/"
                                  : "/stars/"
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                 <IBMainLogo className="ib-main-logo" style={{marginRight:'100px',marginLeft:'20px'}}/>
                 </Link> 
                 </span>}
         
         
              <div className="mainDivSearchBarForBrand">
                {/* {isColor && showTitleHeader && <div className="grayRound" />} */}
                
          
                <div className="searchBarItems" id="autoCompleteDiv">
                  <span className="searchIcon">
                    {/* {selectedSearchOption === "Images Search" ? (
                      <span onClick={handleUploadModalOpen}>
                        <img src={upload} alt="upload" />
                        {uploadedImageData && (
                        <span style={{ display: 'inline-block', width: '70px' }}>
                          <img src={uploadedImageData} alt="hello" style={{ width: '100%', height: 'auto' }} />
                        </span>
                      )}
                      </span>
                    ) : (<> */}
                      <img src={SearchIcon} alt="SearchIcon" />
                      {/* </> */}
                    {/* )} */}
                  </span>
                  <input
                    type="text"
                    className="searchInputType mainpagetitle"
                    placeholder="Search the largest collection of Indian images"
                    onChange={(event) => {
                      setSearchText(event.target.value);
                      if (event.target.value && event.target.value.length > 0) {
                        let callSearch = debounce(async function () {
                          let res = await autosuggest(event.target.value);
                          setAutoComplete(res?.rows);
                          setShowAutoComplete(true);
                        }, 150);
                        callSearch();
                      } else {
                        setAutoComplete([]);
                      }
                    }}
                    style={animationStyle}
                    value={searchText === "color images" ? "" : searchText}
                    autoComplete="off"
                    onFocus={(event) => {
                      if (searchText && searchText.length > 0) {
                        let callSearch = debounce(async function () {
                          let res = await autosuggest(searchText);
                          setAutoComplete(res?.rows);
                          setShowAutoComplete(true);
                        }, 150);
                        callSearch();
                      } else {
                        setAutoComplete([]);
                      }
                    }}
                    onKeyDown={handleKeyDown}
                  />
                  {autoComplete?.length && showAutoComplete ? (
                    <div
                      className="autocomplete"
                      style={animationDropDownStyle}
                    >
                      {autoComplete?.map((item, index) => {
                        return (
                          <div
                            className={`autocomplete_inner ${
                              cursor === index ? "active" : null
                            }`}
                            key={Math.random().toString()}
                            onClick={async () => {
                              setSearchText(item?.displayKeyword);
                              setShowAutoComplete(false);
                              if (selectedSearchOption === "Images") {
                                if (tabContent === "stars") {
                                  navigate(
                                    `/stars/search/${item?.displayKeyword}`
                                  );
                                } else {
                                  navigate(`/search/${item?.displayKeyword}`);
                                }
                              } else if (
                                selectedSearchOption === "Images Search"
                              ) {
                                navigate(`/image-search/search`);
                              } else {
                                navigate(
                                  `/video/search/${item?.displayKeyword}`
                                );
                              }
                            }}
                          >
                            {item?.displayKeyword}
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                  <div className="searchbar-select-options">
                    <div
                      className="searchBar-select-button"
                      onClick={() => setIsOpenDropDown(!isOpenDropDown)}
                    >
                      <div className="divider-search-bar"></div>
                      <Typography
                        component="div"
                        variant="mainpagetitle"
                        className="boldFont text-searchBar"
                      >
                        {selectedSearchOption}
                      </Typography>
                      <DownArrow className="down-arrow-searchBar" />
                      {isOpenDropDown && (
                        <ClickAwayListener
                          onClickAway={() => setIsOpenDropDown(!isOpenDropDown)}
                        >
                          <div className="searchbar-select-options-menu">
                            <Typography
                              component="div"
                              variant="mainsectiontitle"
                              onClick={() => {
                                if (searchText?.toString()?.length > 0) {
                                  setSelectedSearchOption("Images");
                                  handleSubmitChangeOfSelect("Images");
                                } else {
                                  setSelectedSearchOption("Images");
                                  if (
                                    location?.pathname?.includes("image-search")
                                  ) {
                                    navigate("/");
                                  }
                                }
                                if (selectedMenuType) {
                                  searchParams.delete("menu_type");
                                  setSearchParams(searchParams);
                                }
                              }}
                              className="boldFont searchBar-select-box-options"
                              sx={{
                                borderBottom:
                                  "1px solid rgba(205, 205, 205, 1)",
                              }}
                            >
                              Images
                            </Typography>
                            <Typography
                              component="div"
                              variant="mainsectiontitle"
                              onClick={() => {
                                if (searchText?.toString()?.length > 0) {
                                  setSelectedSearchOption("Videos");
                                  handleSubmitChangeOfSelect("Videos");
                                } else {
                                  setSelectedSearchOption("Videos");
                                  if (
                                    searchKeyword &&
                                    String(searchKeyword)?.length > 0
                                  ) {
                                    navigate(`/video/search/${searchKeyword}`);
                                  } else {
                                    if (
                                      location?.pathname?.includes(
                                        "image-search"
                                      )
                                    ) {
                                      navigate("/?menu_type=video");
                                    } else navigate("?menu_type=video");
                                  }
                                }
                              }}
                              className="boldFont searchBar-select-box-options"
                            >
                              Videos
                            </Typography>
                            {/* <Typography
                              component="div"
                              variant="mainsectiontitle"
                              onClick={() => {
                                if (searchText?.toString()?.length > 0) {
                                  setSelectedSearchOption("Images Search");
                                  handleSubmitChangeOfSelect("Images Search");
                                } else {
                                  setSelectedSearchOption("Images Search");
                                  navigate("/?menu_type=image-search");
                                }
                              }}
                              className="boldFont searchBar-select-box-options"
                              sx={{
                                borderBottom:
                                  "1px solid rgba(205, 205, 205, 1)",
                              }}
                            >
                              Images Search
                            </Typography> */}
                          </div>
                        </ClickAwayListener>
                      )}
                    </div>
                    <div className="divider-search-bar"></div>
                    <button onClick={() => {
                                handleAllFunctionForUploadModal();
                              }}
                                className="searchBar-uplod-box">
                      <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="TixbEK6WYmZooFdTSfyb"><g clip-path="url(#clip0_994_14909)" fill="#080808"><path d="M2.026 21.404H0v-2.09h1.215v.836h.81v1.254zM1.215 16.675H0v-2.643h1.215v2.643zm0-5.285H0V8.75h1.215v2.639zM1.215 6.105H0v-2.09h2.026v1.254h-.81v.836zM12.262 5.272h-2.56V4.018h2.56v1.254zm-5.116 0h-2.56V4.018h2.552l.008 1.254zM9.759 15.178a2.094 2.094 0 01-1.502-.645 2.231 2.231 0 01-.621-1.55c0-.582.224-1.14.621-1.551a2.094 2.094 0 011.502-.644 2.098 2.098 0 011.502.644c.399.411.623.969.625 1.55 0 .583-.225 1.141-.623 1.553-.4.412-.94.643-1.504.643zm0-3.345a1.097 1.097 0 00-.785.338 1.169 1.169 0 00-.325.812c0 .304.117.596.325.811.208.216.49.338.785.339.295 0 .579-.121.787-.337a1.17 1.17 0 00.327-.813c0-.305-.118-.598-.326-.813a1.097 1.097 0 00-.788-.337z"></path><path d="M19.955 0a6.944 6.944 0 00-4.976 2.134 7.4 7.4 0 00-2.064 5.137c0 .184 0 .368.028.552H3.82v17.181h16.642v-10.49a6.965 6.965 0 004.638-2.301 7.405 7.405 0 001.888-4.942 7.4 7.4 0 00-2.062-5.134A6.944 6.944 0 0019.956 0zm-.506 23.959H4.833v-2.626l2.97-2.927 2.333 2.409 4.95-5.106 4.363 4.508v3.742zm0-5.21l-4.363-4.5-4.95 5.102-2.318-2.392-2.985 2.927V8.864h8.26a7.317 7.317 0 002.276 3.905 6.93 6.93 0 004.08 1.74v4.24zm3.61-10.529l-2.27-2.341v5.436h-1.446V5.879L17.072 8.22l-1.02-1.053 4.014-4.14 4.014 4.14-1.02 1.053z"></path></g><defs><clipPath id="clip0_994_14909"><path fill="#fff" d="M0 0h27v25H0z"></path></clipPath></defs></svg>
                      <span className="searchBar-uplod-box-span">Search by image</span>
                    </button>
                  </div>
                </div>
              </div>
              
              </div>      
            <UploadImageModal
              open={isUploadModalOpen}
              handleOpen={handleUploadModalClose}
              handleLast={handleLasts}
            />
          </>
        )}
      </Box>
    </>
  );
};

export default SearchBar;
